module.exports = {
  DEFAULT_PROFILE: 'default'
};